import { createSelector } from 'reselect';
import { GlobalState } from 'store/types';
import { KEY } from './';

const getSettingsState = (state: GlobalState) => state[KEY];

const selectConfigurationId = createSelector(getSettingsState, (settings) => settings.configurationId);

const selectClientIntegrationId = createSelector(getSettingsState, (settings) => settings.clientIntegrationId);

export const selectors = {
  selectConfigurationId,
  selectClientIntegrationId
};
